import { Typography } from "@mui/material";
import "../assets/css/Error.css";

const Error = () => {
  return (
    <div className="error-container">
      <div className="error-content">
        <Typography variant="h1" className="error-title" fontWeight={900}>
          404
        </Typography>
        <Typography variant="h2" className="error-subtitle">
          Error
        </Typography>
      </div>
      <img
        className="error-image"
        src="https://lh3.googleusercontent.com/mV6HWiklQWTvZFvEW7XpAvVYan9dYSXOrZ5VXEK0QilaTb2mqmdBYC6mINdL8gUhIxG0ADbY9RnALnYGAzKfoiqju7fyztWSRdgwguJB4Q"
      />
      <img
        className="error-image-bottom"
        src="https://lh3.googleusercontent.com/mV6HWiklQWTvZFvEW7XpAvVYan9dYSXOrZ5VXEK0QilaTb2mqmdBYC6mINdL8gUhIxG0ADbY9RnALnYGAzKfoiqju7fyztWSRdgwguJB4Q"
      />
    </div>
  );
};

export default Error;